// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g6xg8ILaj951xO {
  padding: 10px;
}
.g6xg8ILaj951xO .kZ0PpEjw7qLCon {
  font-weight: 400;
}
.g6xg8ILaj951xO .GzQbGkMxGY_uEy {
  margin-top: 40px;
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: 600;
  margin-top: 25px;
}
.g6xg8ILaj951xO .lrgy2eLxa2r_DO {
  font-weight: 400;
  display: flex;
  align-items: center;
  min-height: 64px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.g6xg8ILaj951xO .f3n4sVtTM6oqKC {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: 600;
  overflow-wrap: break-word;
  font-size: 26px;
}
.g6xg8ILaj951xO .TeTtWlmRDWkDU5,
.g6xg8ILaj951xO .pgoFfhMJhsRJDS,
.g6xg8ILaj951xO .yEpJUJzfdG71Jk {
  font-weight: 400;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.g6xg8ILaj951xO .pgoFfhMJhsRJDS {
  margin: 32px 25px 25px 30px;
}
.g6xg8ILaj951xO:nth-last-child(2) {
  border-top: 3px solid var(--ds-border-discovery, #8270db);
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.g6xg8ILaj951xO:nth-last-child(2) .GzQbGkMxGY_uEy {
  margin-top: 3px;
}
.g6xg8ILaj951xO:nth-last-child(2)::before {
  margin-top: 20px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  content: attr(data-value);
  position: relative;
  top: -15px;
  width: 85px;
  height: 24px;
  padding: 5px;
  border-radius: 2px;
  background-color: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  line-height: inherit;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCell": `g6xg8ILaj951xO`,
	"purchase": `kZ0PpEjw7qLCon`,
	"name": `GzQbGkMxGY_uEy`,
	"info": `lrgy2eLxa2r_DO`,
	"price": `f3n4sVtTM6oqKC`,
	"frequency": `TeTtWlmRDWkDU5`,
	"pricingVaries": `pgoFfhMJhsRJDS`,
	"currentPlan": `yEpJUJzfdG71Jk`
};
export default ___CSS_LOADER_EXPORT___;
